/* eslint-disable import/prefer-default-export */
/**
 * Common properties for form components
 */

export enum FormType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
}

export interface FormComponentsBaseProps {
    label: string;
    name: string;
    touched?: boolean;
    errors?: string;
    isRequired?: boolean;
    helpBlock?: string;
}

export interface ModalFormComponentsProps extends FormComponentsBaseProps {
    testId: string;
}

/**
 * Common properties for modal forms
 */
export interface ModalFormBaseProps {
    title: String;
    toggleButton: JSX.Element;
    formType: FormType;
    onSubmit?: () => void;
}
